import React, { Fragment } from "react";

export default function OrderSummary(props) {
  const { shoppingCart } = props;
  if (shoppingCart) {
    let showSubTotal =
      shoppingCart.TotalShippingCostForPhysicalcards > 0 ||
      shoppingCart.TotalShippingCostForCustomPhysicalCards > 0 ||
      shoppingCart.TotalExtraChargeForCustomPhysicalCards > 0 ||
      shoppingCart.TotalCostForSKFTip > 0;
    return (
      <Fragment>
        <h2>Order Summary</h2>
        <div className="line-items">
          {showSubTotal && (
            <div className="line-item">
              <div className="line-item-description">
                Subtotal ({shoppingCart.Items.length} item
                {shoppingCart.Items.length === 1 ? "" : "s"})
              </div>
              <div className="line-item-amount">
                ${shoppingCart.TotalCostForCards.toFixed(2)}
              </div>
            </div>
          )}
          {shoppingCart.TotalShippingCostForPhysicalcards > 0 && (
            <div className="line-item">
              <div className="line-item-description">
                Shipping Cost for Physical Cards
              </div>
              <div className="line-item-amount">
                ${shoppingCart.TotalShippingCostForPhysicalcards.toFixed(2)}
              </div>
            </div>
          )}
          {shoppingCart.TotalShippingCostForCustomPhysicalCards > 0 && (
            <div className="line-item">
              <div className="line-item-description">
                Shipping Cost for Custom Physical Cards
              </div>
              <div className="line-item-amount">
                $
                {shoppingCart.TotalShippingCostForCustomPhysicalCards.toFixed(
                2
              )}
              </div>
            </div>
          )}
          {shoppingCart.TotalPrintChargeForCustomPhysicalCards > 0 && (
            <div className="line-item">
              <div className="line-item-description">
                Printing of Custom Physical Cards
              </div>
              <div className="line-item-amount">
                $
                {shoppingCart.TotalPrintChargeForCustomPhysicalCards.toFixed(2)}
              </div>
            </div>
          )}
          {shoppingCart.TotalSetupChargeForCustomPhysicalCards > 0 && (
            <div className="line-item">
              <div className="line-item-description">
                Set-up of Custom Physical Cards
              </div>
              <div className="line-item-amount">
                $
                {shoppingCart.TotalSetupChargeForCustomPhysicalCards.toFixed(2)}
              </div>
            </div>
          )}
          {shoppingCart.TotalCostForSKFTip > 0 && (
            <div className="line-item">
              <div className="line-item-description">Tips for Special Kids</div>
              <div className="line-item-amount">
                ${shoppingCart.TotalCostForSKFTip.toFixed(2)}
              </div>
            </div>
          )}
          <div className="line-item">
            <div className="line-item-description">Grand Total</div>
            <div className="line-item-amount">
              ${shoppingCart.GrandTotal.toFixed(2)}
            </div>
          </div>
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <h2>Order Summary</h2>
        <div className="line-items">
          <div className="line-item">
            <div className="line-item-description">Grand Total</div>
            <div className="line-item-amount">$0.00</div>
          </div>
        </div>
      </Fragment>
    );
  }
}
